import { WaterCharacteristicsParameters } from "@imi-ernd-be/hyselect-engine";
import { setIfNotNil } from "@src/shared/helpers/setIfNotNil";

export type WaterCharacteristics = {
  additives: string | null;
  defaultDifferentialTemperature: number | null;
  supplyTemperature: number | null;
  weight?: number | null;
};

export function buildEngineWaterCharacteristics(
  waterCharacteristics: WaterCharacteristicsParameters,
  values?: WaterCharacteristics,
) {
  setIfNotNil(
    waterCharacteristics.setSelectedAdditive.bind(waterCharacteristics),
    values?.additives,
  );
  setIfNotNil(
    waterCharacteristics.setWaterCharPcWeight.bind(waterCharacteristics),
    values?.weight,
  );
  setIfNotNil(
    waterCharacteristics.setWaterCharDiffTemp.bind(waterCharacteristics),
    values?.defaultDifferentialTemperature,
  );
  setIfNotNil(
    waterCharacteristics.setWaterCharSupplyTemp.bind(waterCharacteristics),
    values?.supplyTemperature,
  );

  return waterCharacteristics;
}
